<div class="container">
      <div class="products" style="background: white; padding-top: 0; min-height: auto;">
<div class="content-container">
  
  <div class="inner">
    <div class="flex-wrap scroll_cards_uat_live">
          <form name="ob-payee-code-form" id="ob-payee-code-form" data-k2-validation="true" class="col-sm-10" style="padding: 0" (ngSubmit)="submit(true)">
            

              <div class="row">
                <div class="box-uat col-md-12 mrgn-btm-1rem">
                  
                  <h3 class="title-primary"><strong>Upload Your Documents </strong></h3>
                  <hr style="border: 1px solid #FFC83D;">
                  <p style="color:#FFC83D; margin-bottom: 12px;">Not sure what documents to upload? Refer here.</p>

                  <p style="color:#FFC83D">We only accept documents uploaded in PDF format only.</p>   
                </div>
              <p>
                <div class="box-uat col-md-12">
                  <div class="row">
                      <div class="col-md-12">
                          <h4> Letter Of Offer *</h4>
                          <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="usignedJompayLoSrc">
                              <input (change)="addDoc('signed_jompay_lo', $event, false, submission.submission_id, submission.payee_id, 'Customer')" accept=".pdf, application/pdf" #JompayLOInput type="file" name="usignedJompayLoSrc"/>
                          </div>
                      </div>
                      <p *ngIf="usignedJompayLoSrc">{{usignedJompayLoSrc}}</p>
                  </div>
                </div>

                <div class="box-uat col-md-12">
                  <div class="row">
                      <div class="col-md-12">
                          <h4>Service Agreement *</h4>
                          <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="usignedJompaySaSrc">
                              <input (change)="
                              addDoc('signed_jompay_sa', $event, false, submission.submission_id, submission.payee_id, 'Customer')" accept=".pdf, application/pdf" #JompaySAInput type="file" name="usignedJompaySaSrc"/>
                          </div>
                      </div>
                      <p *ngIf="usignedJompaySaSrc">{{usignedJompaySaSrc}}</p>
                  </div>
                </div>
                <div class="box-uat col-md-12">
                  <div class="row">
                      <div class="col-md-12">
                          <h4>Upliftment of Collection Account Blocking letter & Letter of Authorization *</h4>
                          <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="usignedJompayAccAuthSrc">
                              <input (change)="
                              addDoc('signed_jompay_accauth', $event, false, submission.submission_id, submission.payee_id, 'Customer')" accept=".pdf, application/pdf" #JompayAccAuthInput type="file" name="usignedJompayAccAuthSrc"/>
                          </div>
                      </div>
                      <p *ngIf="usignedJompayAccAuthSrc">{{usignedJompayAccAuthSrc}}</p>
                  </div>
              </div>
              <div class="row" [hidden]="valid || docsValid">
                <div class="col-md-12">
                    <label class="red">All documents marked with a * are required</label>
                </div>
              </div>

              <div class="box-uat col-md-12">
                <div class="group">
                    <div class="row">
                        <div *ngIf="uploader" [hidden]="(usignedJompayLoSrc || usignedJompaySaSrc || usignedJompayAccAuthSrc)">
                            Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                            <div class="progress">
                                <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                    <span style="opacity: 0">...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>              
            </div>

            <div id="row">
              <div class="col-md-3">
                <button type="submit" class="btn btn-primary btn-block center" >Submit</button>
              </div>
              <div class="col-md-9"></div>
            </div>
          </form>
    </div>
  </div>
</div>
</div>
</div>
